export class Document {
  constructor() {
    this.url = "";
  }
  public url: string;
  public size?: number;
  public documentType?: string;
}
